<div
  *ngIf="loading"
  class="position-fixed top-0 vw-100 vh-100 d-flex align-items-center justify-content-center"
  style="background-color: rgba(0, 0, 0, 0.5); z-index: 1000"
>
  <div class="spinner-border" role="status"></div>
</div>
<div class="d-flex flex-column align-items-center justify-content-center">
  <div class="landing2Wrapper">
    <h2 class="fw-light">
      {{ 'landingTitle' | i18next }} {{ user ? user.fullName : '-' }}
    </h2>
    <div class="header">
      <p class="lead">{{ 'welcome' | i18next }}</p>
      <button mat-button class="header--btn" [routerLink]="['/list-requests']">
        <div class="header--btn__container">
          <p class="header--btn__text">
            {{ 'landingGoTo' | i18next | uppercase }}
            {{ 'landing2MyVehicles' | i18next | uppercase }}
          </p>
          <img
            src="../../../assets/icons/arrow_forward.svg"
            alt="Ir a mi histórico"
          />
        </div>
      </button>
    </div>
    <div class="header">
      <button mat-button class="header--btn" [routerLink]="['/vo']">
        <div class="header--btn__container">
          <p class="header--btn__text">
            {{ 'landingGoTo' | i18next | uppercase }}
            {{ 'reservationsVO' | i18next | uppercase }}
          </p>
          <img
            src="../../../assets/icons/arrow_forward.svg"
            alt="Ir a mi histórico"
          />
        </div>
      </button>
      <button mat-button class="header--btn" [routerLink]="['/relatives-vo']">
        <div class="header--btn__container">
          <p class="header--btn__text">
            {{ 'landingGoTo' | i18next | uppercase }}
            {{ 'myRelatives' | i18next | uppercase }}
          </p>
          <img
            src="../../../assets/icons/arrow_forward.svg"
            alt="Ir a familiares"
          />
        </div>
      </button>
    </div>
    <div class="d-flex flex-wrap gap-2">
      <button
        type="button"
        class="btn btn-dark"
        (click)="scrollDown('myVehicles')"
      >
        {{ 'myVehicles' | i18next }}
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="scrollDown('myRequests')"
      >
        {{ 'myRequests' | i18next }}
      </button>
      <button
        *ngIf="employeeLeasing?.sections?.length >= 1"
        type="button"
        class="btn btn-primary"
        (click)="scrollDown('leasing')"
      >
        {{ 'typeLeasing' | i18next }}
      </button>
      <button
        *ngIf="campaigns.length > 0"
        type="button"
        class="btn btn-primary"
        (click)="scrollDown('campaigns')"
      >
        {{ 'campaigns' | i18next }}
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="scrollDown('electrification')"
      >
        <div class="d-flex align-items-center gap-2 text-uppercase">
          <img
            src="../../../assets/icons/info_black.svg"
            alt="icon"
            width="20px"
          />
          {{ 'joinElectrification' | i18next }}
        </div>
      </button>
    </div>

    <!-- MY VEHICLES -->
    <div id="myVehicles" class="my-4 pt-4">
      <h4 class="fw-light">{{ 'myVehicles' | i18next }}</h4>
      <!-- LOADING -->
      <div *ngIf="loading" class="w-100 placeholder-glow">
        <span
          class="w-100 placeholder"
          style="height: 450px; border-radius: 20px"
        ></span>
      </div>

      <!-- NO VEHICLES -->
      <div
        *ngIf="myVehicles.length === 0 && !loading"
        class="d-flex flex-column w-100 gap-4 p-4 align-items-center justify-content-center"
        style="height: 450px"
      >
        <div
          class="p-4 rounded-circle d-flex align-items-center justify-content-center"
          style="background-color: #6b6a69; width: 80px; height: 80px"
        >
          <img
            src="../../../assets/icons/car.svg"
            alt="vehicle"
            style="width: 50px"
          />
        </div>
        <div class="text-center">
          <h5 class="fw-light">{{ 'noRequestedVehicles' | i18next }}</h5>
          <p class="fw-light">{{ 'newEmotions' | i18next }}</p>
        </div>
      </div>

      <!-- VEHICLES -->
      <div *ngIf="myVehicles.length >= 1 && !loading">
        <ul id="vehicleHeaderSelector" class="nav nav-tabs my-4">
          <li
            class="nav-item"
            *ngFor="let car of myVehicles; let i = index"
            (click)="selectCar(i)"
          >
            <span
              [class]="
                'text-truncate nav-link ' + (i === activeCar ? 'active' : '')
              "
              style="cursor: pointer; text-transform: uppercase"
            >
              {{ car.model | valueData }}
            </span>
          </li>
        </ul>
        <ngb-carousel
          #carousel
          [showNavigationIndicators]="myVehicles.length >= 1"
          [showNavigationArrows]="false"
          [interval]="0"
          [activeId]="activeCar.toString()"
          (slide)="selectCarCarousel($event)"
        >
          <ng-template
            ngbSlide
            *ngFor="let vehicle of myVehicles; let i = index"
            id="{{ i }}"
          >
            <div style="margin-bottom: 40px">
              <div class="myVehicleCardWrapper">
                <div class="myVehicleCardWrapper--status">
                  <span
                    *ngIf="vehicle.requestSubsNumber"
                    class="requestStatusTag text-truncate text-uppercase"
                    >{{ 'statusSubstitution' | i18next }}</span
                  >
                  <span
                    *ngIf="vehicle.booking"
                    class="vehicleStatusTag text-truncate text-uppercase"
                    >{{ 'tagBooked' | i18next }}</span
                  >
                  <span
                    *ngIf="vehicle.appraisalRequested"
                    class="vehicleStatusTag text-truncate text-uppercase"
                    >{{ 'tagAppraisal' | i18next }}</span
                  >
                  <span
                    *ngIf="vehicle.appraisalFinished"
                    class="vehicleStatusTag text-truncate text-uppercase"
                    >{{ 'tagAppraisalCompleted' | i18next }}</span
                  >
                </div>
                <div class="myVehicleCardWrapper--image">
                  <img
                    class="myVehicleCardWrapper--image__image"
                    [src]="
                      vehicle.image ||
                      '../../../../assets/img/NeutroNaranjaRojo_v2.png'
                    "
                    alt="Imagen vehículo"
                  />
                </div>
                <div class="myVehicleCardWrapper--content">
                  <div class="myVehicleCardWrapper--content__modelInfo">
                    <div class="d-flex flex-column gap-1">
                      <div>
                        <span class="typeTag fw-light">{{
                          vehicle.type | i18next
                        }}</span>
                      </div>
                      <span class="fw-light">{{
                        vehicle.fuelType | valueData
                      }}</span>
                      <span
                        class="myVehicleCardWrapper--content__modelInfo__model"
                        >{{ vehicle.model | valueData }}</span
                      >
                    </div>
                    <div>
                      <div
                        class="myVehicleCardWrapper--content__options"
                        [matMenuTriggerFor]="menu"
                      >
                        <span class="fw-bold text-uppercase">{{
                          'options' | i18next
                        }}</span>
                        <img
                          src="../../../assets/icons/more_vert.svg"
                          alt="icon"
                          width="20px"
                        />
                      </div>
                      <mat-menu
                        #menu="matMenu"
                        style="position: absolute"
                        class="menuWhite"
                      >
                        <div class="d-flex flex-column gap-2 align-items-start">
                          <button
                            *ngIf="!vehicle.requestSubsNumber"
                            class="btn"
                            (click)="
                              onVehicleOptionSelected(vehicle, 'replace')
                            "
                          >
                            {{ 'replace' | i18next }}
                          </button>
                          <button
                            *ngIf="
                              vehicle.type != 'employeeLeasing' &&
                              !vehicle.appraisalRequested
                            "
                            class="btn"
                            (click)="
                              onVehicleOptionSelected(vehicle, 'appraise')
                            "
                          >
                            {{ 'appraise' | i18next }}
                          </button>
                          <button
                            *ngIf="
                              vehicle.type != 'employeeLeasing' &&
                              !vehicle.booking
                            "
                            class="btn"
                            (click)="onVehicleOptionSelected(vehicle, 'book')"
                          >
                            {{ 'book' | i18next }}
                          </button>
                          <button
                            class="btn"
                            (click)="
                              onVehicleOptionSelected(
                                vehicle,
                                'viewRequestDetail'
                              )
                            "
                          >
                            {{ 'viewRequestDetail' | i18next }}
                          </button>
                        </div>
                      </mat-menu>
                    </div>
                  </div>
                  <div>
                    <div class="d-flex justify-content-between mb-2">
                      <div class="d-flex flex-column w-100 gap-1">
                        <span class="text-black">{{
                          'plateNumber' | i18next
                        }}</span>
                        <span class="text-black fw-bold">{{
                          vehicle.plateNumber | valueData
                        }}</span>
                      </div>
                      <div
                        class="d-flex flex-column w-100 gap-1"
                        style="align-items: center; margin-right: 20px"
                      >
                        <div class="d-flex flex-column gap-1">
                          <span class="text-black">{{
                            'deliveryDate' | i18next
                          }}</span>
                          <span class="text-black fw-bold">{{
                            vehicle.deliveryDate
                              ? isValidDate(vehicle.deliveryDate)
                                ? (vehicle.deliveryDate | date: 'dd/MM/yyyy')
                                : vehicle.deliveryDate
                              : ('noData' | i18next)
                          }}</span>
                        </div>
                      </div>
                      <div
                        class="d-flex w-100"
                        style="align-items: flex-end; justify-content: flex-end"
                      >
                        <div class="d-flex flex-column gap-1">
                          <span class="text-black">{{
                            'expectedReturnDate' | i18next
                          }}</span>
                          <span
                            class="text-black fw-bold text-left"
                            title="{{ 'returnDateTooltip' | i18next }}"
                            >{{
                              isValidDate(vehicle.deliveryDate)
                                ? (getVehicleReturnDate(vehicle)
                                  | date: 'dd/MM/yyyy')
                                : getVehicleReturnDate(vehicle)
                            }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="d-flex justify-content-between">
                      <div class="d-flex flex-column w-100 gap-1">
                        <span class="text-black">{{
                          'requestNum' | i18next
                        }}</span>
                        <span class="text-black fw-bold">{{
                          vehicle.type != 'employeeLeasing'
                            ? vehicle.requestNumber
                            : (vehicle.showId | valueData)
                        }}</span>
                      </div>
                      <div
                        *ngIf="!vehicle.requestSubsNumber"
                        class="d-flex flex-column w-100 gap-1"
                      ></div>
                      <div
                        *ngIf="vehicle.requestSubsNumber"
                        class="d-flex flex-column w-100 gap-1"
                        style="align-items: center"
                      >
                        <div class="d-flex flex-column gap-1">
                          <span class="text-black">{{
                            'requestSubsNum' | i18next
                          }}</span>
                          <span class="text-black fw-bold">{{
                            vehicle.requestSubsNumber | valueData
                          }}</span>
                        </div>
                      </div>
                      <div
                        class="w-100 d-flex justify-content-end align-items-end"
                      >
                        <button
                          type="button"
                          class="knowYourCarButton btn btn-dark"
                          [matMenuTriggerFor]="knowYourCarMenu"
                        >
                          <div
                            class="d-flex align-items-center gap-2 text-uppercase"
                          >
                            <img
                              src="../../../assets/icons/info.svg"
                              alt="icon"
                              width="20px"
                            />
                            <span>{{ 'knowYourCar' | i18next }}</span>
                          </div>
                        </button>
                        <mat-menu
                          #knowYourCarMenu="matMenu"
                          style="position: absolute"
                          class="menuWhite"
                        >
                          <div
                            class="d-flex flex-column gap-2 align-items-start"
                          >
                            <button
                              class="btn"
                              (click)="
                                onVehicleOptionSelected(
                                  vehicle,
                                  'liveTheExperience'
                                )
                              "
                            >
                              {{ 'liveTheExperience' | i18next }}
                            </button>
                            <button
                              class="btn"
                              (click)="
                                onVehicleOptionSelected(vehicle, 'yourCarInfo')
                              "
                            >
                              {{ 'yourCarInfo' | i18next }}
                            </button>
                          </div>
                        </mat-menu>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ngb-carousel>
      </div>
    </div>

    <!-- MY REQUESTS -->
    <div id="myRequests" class="my-4">
      <h4 class="fw-light">{{ 'myRequests' | i18next }}</h4>
      <!-- LOADING -->
      <div *ngIf="loading" class="w-100 placeholder-glow">
        <span
          class="w-100 placeholder"
          style="height: 500px; border-radius: 20px"
        ></span>
      </div>

      <!-- REQUESTS -->
      <div *ngIf="!loading">
        <div class="d-flex flex-row flex-wrap gap-2 types-request-block">
          <p class="fw-light text-nowrap">{{ 'youCanRequest' | i18next }}</p>
          <p class="fw-light">|</p>
          <div
            *ngIf="!isExp() && requestsInfo.endowmentLeasingEndowment.max > 0"
            class="d-flex flex-row gap-2 types-request-item"
          >
            <p class="fw-bold">{{ 'typeEndowment' | i18next }}</p>
            <p class="fw-light">
              {{ requestsInfo.endowmentLeasingEndowment.left }}/{{
                requestsInfo.endowmentLeasingEndowment.max
              }}
            </p>
            <p class="fw-light">|</p>
          </div>
          <div
            *ngIf="requestsInfo.endowmentLeasingLeasing.max > 0"
            class="d-flex flex-row gap-2 types-request-item"
          >
            <p class="fw-bold">{{ 'typeArr' | i18next }}</p>
            <p class="fw-light">
              {{ requestsInfo.endowmentLeasingLeasing.left }}/{{
                requestsInfo.endowmentLeasingLeasing.max
              }}
            </p>
            <p *ngIf="!isExp()" class="fw-light">|</p>
          </div>
          <div
            *ngIf="!isExp()"
            class="d-flex flex-row gap-2 types-request-item"
          >
            <p class="fw-bold">{{ 'typeLeasing' | i18next }}</p>
            <p class="fw-light">
              {{ requestsInfo.leasing.left }}/{{ requestsInfo.leasing.max }}
            </p>
          </div>
        </div>
        <div style="width: 100%; overflow-x: auto">
          <div
            class="d-flex flex-row align-items-center justify-content-start mt-2"
            style="max-width: 1420px; gap: 19.375px; flex-shrink: 0"
          >
            <div
              *ngFor="let request of requests"
              class="requestedCarCard"
              style="position: relative"
            >
              <div
                style="position: absolute; top: 10px"
                class="d-flex flex-column gap-1"
              >
                <!--<span
                [class]="
                  'typeTag fw-light d-flex align-items-center ' +
                  getRequestStatusClass(request.requestStatus)
                "
              >
                <img
                  [src]="getRequestStatusIcon(request.requestStatus)"
                  alt="icon"
                  width="14px"
                />
                <span>{{
                  getRequestStatusText(request.requestStatus) | i18next
                }}</span>
              </span>-->
                <span class="requestStatusTag text-truncate">{{
                  getRequestStatusText(request) | i18next
                }}</span>
                <!--<span
                *ngIf="request.raffleAssignmentStatus"
                [class]="
                  'typeTag fw-light d-flex align-items-center ' +
                  getRaffleStatusClass(request.raffleAssignmentStatus)
                "
              >
                <img
                  [src]="getRaffleStatusIcon(request.raffleAssignmentStatus)"
                  alt="icon"
                  width="14px"
                />
                <span
                  >{{ 'raffleStatus' | i18next
                  }}{{
                    translate.translateCampaignRaffleStatus(
                      request.raffleAssignmentStatus
                    )
                  }}</span
                >
              </span>-->
                <span
                  *ngIf="request.campaign?.raffleAssignmentStatus"
                  class="raffleStatusTag text-truncate"
                >
                  {{ 'raffleStatus' | i18next
                  }}{{
                    translate.translateCampaignRaffleStatus(
                      request.campaign.raffleAssignmentStatus
                    )
                  }}
                </span>
              </div>
              <div
                style="height: 50%"
                class="d-flex align-items-center justify-content-center"
              >
                <img
                  [src]="
                    request.showVehicle &&
                    request.showVehicle.vin &&
                    request.showVehicle.image
                      ? request.showVehicle.image
                      : '../../../../assets/img/NeutroNaranjaRojo_v2.png'
                  "
                  alt="request"
                  style="width: 100%"
                />
              </div>
              <div
                class="d-flex flex-column gap-1 justify-content-between text-truncate"
                style="height: 50%; width: 268.5px !important"
              >
                <div class="d-flex flex-column gap-1">
                  <div>
                    <span class="typeTag fw-light text-truncate">{{
                      request.type | i18next
                    }}</span>
                  </div>
                  <span
                    *ngIf="request.showVehicle"
                    class="fw-light text-truncate"
                    >{{ request.showVehicle.fuelType | valueData }}</span
                  >
                </div>
                <div class="d-flex flex-column gap-1">
                  <span
                    *ngIf="request.showVehicle"
                    class="mt-2 text-black text-uppercase lead fw-bold text-truncate"
                    title="{{ request.showVehicle.model | valueData }}"
                    >{{ request.showVehicle.model | valueData }}</span
                  >
                  <span class="text-muted mt-2 text-truncate"
                    >{{ 'requestNum' | i18next }}:
                    <span
                      class="fw-bold text-truncate"
                      style="text-decoration: underline"
                      >{{
                        request.type != 'employeeLeasing'
                          ? request.requestNumber
                          : (request.showId | valueData)
                      }}</span
                    ></span
                  >
                  <span
                    *ngIf="request.deliveryDate"
                    class="text-muted text-truncate"
                    title="{{ 'entryDate' | i18next }}: {{
                      isValidDate(request.deliveryDate)
                        ? (request.deliveryDate | date: 'dd/MM/yyyy')
                        : request.deliveryDate
                    }}"
                    >{{ 'entryDate' | i18next }}:
                    {{
                      isValidDate(request.deliveryDate)
                        ? (request.deliveryDate | date: 'dd/MM/yyyy')
                        : request.deliveryDate
                    }}</span
                  >
                  <span
                    *ngIf="request.showVehicle"
                    class="text-muted text-truncate"
                    title="{{ 'plateNumber' | i18next }}: {{
                      request.showVehicle.plateNumber | valueData
                    }}"
                    >{{ 'plateNumber' | i18next }}:
                    {{
                      request.showVehicle.plateNumber
                        ? (request.showVehicle.plateNumber | valueData)
                        : ('authStatusPending' | i18next)
                    }}</span
                  >
                  <span
                    *ngIf="!request.deliveryDate"
                    class="text-muted text-truncate opacity-0"
                    >invisible</span
                  >
                </div>
                <button
                  type="button"
                  class="btn btn-primary mt-2 text-uppercase btn-block"
                  [matMenuTriggerFor]="requestedVehicleOptions"
                >
                  {{ 'options' | i18next }}
                </button>
                <mat-menu
                  #requestedVehicleOptions="matMenu"
                  style="position: absolute"
                  class="menuWhite"
                >
                  <div class="d-flex flex-column gap-2 align-items-start">
                    <button
                      *ngIf="
                        (request.requestStatus === 'PENDING_APPROVAL' ||
                          request.requestStatus === 'NEW_REQUEST') &&
                        request.cancellable
                      "
                      class="btn"
                      (click)="
                        onVehicleOptionSelected(request, 'cancelBooking')
                      "
                    >
                      {{ 'btnCancel' | i18next }}
                    </button>
                    <button
                      class="btn"
                      (click)="
                        onVehicleOptionSelected(request, 'viewRequestDetail')
                      "
                    >
                      {{ 'viewRequestDetail' | i18next }}
                    </button>
                  </div>
                </mat-menu>
              </div>
            </div>
            <div
              *ngIf="
                canRequestMoreVehicles() &&
                requestsInfo.endowmentLeasingEndowment.left > 0
              "
              class="requestCarCard"
              (click)="requestCar('endowmentLeasingEndowment')"
            >
              <img
                src="../../../assets/icons/request_car.svg"
                alt="request"
                style="width: 80px"
              />
              <p class="fw-bold text-center text-wrap">
                {{ 'requestEndowmentCar' | i18next }}
              </p>
            </div>
            <div
              *ngIf="
                canRequestMoreVehicles() &&
                requestsInfo.endowmentLeasingLeasing.left > 0
              "
              class="requestCarCard"
              style="background-color: #f6f5f5"
              (click)="requestCar('endowmentLeasingLeasing')"
            >
              <img
                src="../../../assets/icons/request_car.svg"
                alt="request"
                style="width: 80px"
              />
              <p class="fw-bold text-center text-wrap">
                {{ 'requestLeaseCar' | i18next }}
              </p>
            </div>
            <div
              *ngIf="!isExp() && requestsInfo.leasing.left > 0"
              class="requestCarCard"
              style="background-color: #efecea"
              (click)="requestCar('employeeLeasing')"
            >
              <img
                src="../../../assets/icons/request_car.svg"
                alt="request"
                style="width: 80px"
              />
              <p class="fw-bold text-center text-wrap">
                {{ 'requestLeasingCar' | i18next }}
              </p>
            </div>
            <div
              *ngIf="!canRequestMoreVehicles()"
              class="d-flex flex-column w-100 gap-4 p-4 align-items-center justify-content-center"
              style="height: 500px"
            >
              <div
                class="p-4 rounded-circle d-flex align-items-center justify-content-center"
                style="background-color: #6b6a69; width: 80px; height: 80px"
              >
                <img
                  src="../../../assets/icons/car.svg"
                  alt="vehicle"
                  style="width: 50px"
                />
              </div>
              <div class="text-center">
                <h5 class="fw-light">{{ 'requestVehicleLimit' | i18next }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- LEASING PROGRAM -->
    <div
      *ngIf="employeeLeasing?.sections?.length >= 1"
      id="leasing"
      class="my-4 pt-4"
    >
      <h4 class="fw-light">{{ 'leasingProgram' | i18next }}:</h4>
      <h4 class="fw-light">
        <span class="text-secondary" style="font-size: 0.8em">{{
          'leasingProgramInfo' | i18next
        }}</span>
      </h4>
      <div style="margin-bottom: 10px">
        <img
          style="width: 100%"
          src="../../../assets/img/TU_LEASING_V2.png"
          alt="Imagen Vehiculo Leasing"
        />
      </div>
      <div class="card" [style]="'flex-direction: column'">
        <details *ngFor="let section of employeeLeasing.sections">
          <summary>
            <span class="text-black">{{ section.title }}</span>
          </summary>
          <p [innerHTML]="section.description"></p>
        </details>
      </div>
    </div>
  </div>

  <!-- CAMPAIGNS -->
  <div
    *ngIf="campaigns.length > 0"
    id="campaigns"
    class="w-100 d-flex flex-column gap-4 p-4 align-items-center justify-content-center"
    style="background-color: #373534; border-bottom: 1px solid #565554"
  >
    <div
      style="max-width: 1420px; width: 100%"
      class="d-flex align-items-center justify-content-between pt-2"
    >
      <h4 class="fw-light text-white">{{ 'campaigns' | i18next }}</h4>
    </div>
    <div class="campaignsWrapper">
      <div
        class="d-flex w-100 campaingCard align-items-end"
        [style]="
          'min-width: 300px; height: 600px; background-image: url(' +
          campaign.urlImage +
          ')'
        "
        *ngFor="let campaign of campaigns"
      >
        <div
          class="d-flex flex-column justify-content-between w-100 p-4 gap-1"
          style="height: 350px; background-color: rgba(0, 0, 0, 0.5)"
        >
          <div
            class="d-flex gap-2 align-items-center justify-content-end"
            style="cursor: pointer"
            (click)="openInfoAndConditions(campaign)"
          >
            <img
              src="../../../assets/icons/info_green.svg"
              alt="icon"
              width="20px"
            />
            <span
              class="text-uppercase d-none d-md-block"
              style="color: #c8f546"
            >
              {{ 'infoAndConditions' | i18next }}
            </span>
          </div>
          <!-- Titulo campaña y fecha -->
          <div>
            <div>
              <h2
                class="fw-light text-white text-uppercase"
                *ngIf="campaign.type === campaignTypesEnum.RAFFLE"
              >
                {{ campaign.title }} -
                {{ translate.translateCampaignType(campaign.type) }}
              </h2>
              <h2
                class="fw-light text-white text-uppercase"
                *ngIf="campaign.type !== campaignTypesEnum.RAFFLE"
              >
                {{ campaign.title }}
              </h2>
            </div>
            <span class="text-white fw-light"
              >{{ 'validUntil' | i18next }}
              {{
                isValidDate(campaign.endDate)
                  ? (campaign.endDate | date: 'dd/MM/yyyy')
                  : campaign.endDate
              }}</span
            >
            <p class="text-white fw-light" [title]="campaign.description">
              {{
                campaign.description
                  ? campaign.description.length > 60
                    ? (campaign.description | slice: 0 : 60) + '...'
                    : campaign.description
                  : '-'
              }}
            </p>
          </div>

          <!--Cuota desde y botón realizar solicitud-->
          <div>
            <div
              class="d-flex flex-row align-items-start justify-content-between"
            >
              <div>
                <span class="text-white text-uppercase fw-bold">{{
                  'feeFrom' | i18next
                }}</span>
                <h4 class="text-white fw-light">
                  {{ campaign.minFee | numberData }}€
                </h4>
              </div>
              <div class="d-flex flex-column align-items-end">
                <span class="text-white text-uppercase fw-bold text-end">
                  {{
                    campaign.remainingStock === 0
                      ? ('notStock' | i18next)
                      : ('campaignStock' | i18next)
                  }}
                </span>
                <h4
                  *ngIf="campaign.remainingStock > 0"
                  class="text-white fw-light"
                >
                  {{ campaign.remainingStock }}
                </h4>
              </div>
            </div>
            <div
              class="select d-flex align-items-end justify-content-between mt-2"
            >
              <mat-select
                placeholder="{{
                  campaign.isRequested
                    ? ('requestMade' | i18next)
                    : campaign.raffleInProgress
                      ? ('raffleInProgress' | i18next)
                      : ('requestBtn' | i18next)
                }}"
                (selectionChange)="requestCampaign(campaign, $event.value)"
                class="btn btn-campaign text-uppercase"
                [disabled]="
                  campaign.remainingStock === 0 ||
                  campaign.isRequested ||
                  campaign.raffleInProgress ||
                  vehiclesSelect.length === 0
                "
                [style]="
                  campaign.remainingStock === 0 ||
                  campaign.isRequested ||
                  campaign.raffleInProgress ||
                  vehiclesSelect.length === 0
                    ? { 'background-color': '#efffc1', 'font-weight': 'normal' }
                    : { 'background-color': '#c8f546 !important' }
                "
              >
                <mat-option
                  *ngFor="let vehicle of vehiclesSelect"
                  [value]="vehicle"
                >
                  {{ vehicle.model + vehicle.plateNumber }}
                </mat-option>
              </mat-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ELECTRIFICATION -->
  <div class="electrificationContainer" id="electrification">
    <div style="width: 100%" class="p-4 d-flex flex-column align-items-center">
      <!-- TITULO SECCIÓN -->
      <div
        class="d-flex align-items-center justify-content-between pt-2"
        style="width: 100%; max-width: 1420px"
      >
        <h4 class="fw-light text-white">
          {{ 'joinElectrification' | i18next }}
        </h4>
      </div>

      <!-- CARDS -->
      <div
        class="w-100 d-flex flex-row align-items-center gap-2 py-2"
        style="overflow-x: auto"
      >
        <!-- AUTONOMIA -->
        <div
          class="electrificationCard"
          [ngStyle]="{
            'background-image':
              'url(../../../assets/img/new-cupra-tavascan-2024-my-cupra-app.avif)'
          }"
        >
          <div class="electrificationInterCard">
            <h2
              class="fw-light text-white text-uppercase p-2"
              style="font-size: 24px"
            >
              {{ 'electrificationTitleCardOne' | i18next }}
            </h2>

            <p
              class="text-white fw-light p-2 electrification-subtitle"
              style="font-size: 14px"
            >
              {{ 'electrificationSubtitleCardOne' | i18next }}
            </p>

            <div class="p-2">
              <button
                class="externalLinkButton"
                mat-button
                (click)="
                  navigateToExternalSite(
                    'https://www.cupraofficial.es/hibridos-y-electricos/calculadora-autonomia'
                  )
                "
              >
                {{ 'electrificationLinkCardOne' | i18next }}
              </button>
            </div>
          </div>
        </div>

        <!-- AHORRO -->
        <div
          class="electrificationCard"
          [ngStyle]="{
            'background-image':
              'url(../../../assets/img/cupra-born-vz-electric-hatchback-dark-forest-green.avif)'
          }"
        >
          <div class="electrificationInterCard">
            <h2
              class="fw-light text-white text-uppercase p-2"
              style="font-size: 24px"
            >
              {{ 'electrificationTitleCardTwo' | i18next }}
            </h2>

            <p
              class="text-white fw-light p-2 electrification-subtitle"
              style="font-size: 14px"
            >
              {{ 'electrificationSubtitleCardTwo' | i18next }}
            </p>
            <div class="p-2">
              <button
                class="externalLinkButton"
                mat-button
                (click)="
                  navigateToExternalSite(
                    'https://www.cupraofficial.es/hibridos-y-electricos/calculadora-ahorro'
                  )
                "
              >
                {{ 'electrificationLinkCardTwo' | i18next }}
              </button>
            </div>
          </div>
        </div>

        <!-- RECARGAS -->
        <div
          class="electrificationCard"
          [ngStyle]="{
            'background-image':
              'url(../../../assets/img/cupra-tavascan-vz-trim-tavascan-blue-colour-charging.avif)'
          }"
        >
          <div class="electrificationInterCard">
            <h2
              class="fw-light text-white text-uppercase p-2"
              style="font-size: 24px"
            >
              {{ 'electrificationTitleCardThree' | i18next }}
            </h2>

            <p
              class="text-white fw-light p-2 electrification-subtitle"
              style="font-size: 14px"
            >
              {{ 'electrificationSubtitleCardThree' | i18next }}
            </p>
            <div class="p-2">
              <button
                class="externalLinkButton"
                mat-button
                (click)="
                  navigateToExternalSite(
                    'https://www.cupraofficial.es/hibridos-y-electricos/calculadora-tiempos-carga'
                  )
                "
              >
                {{ 'electrificationLinkCardThree' | i18next }}
              </button>
            </div>
          </div>
        </div>

        <!-- MAPA -->
        <div
          class="electrificationCard"
          [ngStyle]="{
            'background-image':
              'url(../../../assets/img/Premio-a-la-innovacion-a-la-app-CUPRA-Easy-Charging-que-da-acceso-a-la-mayor-red-de-recarga-de-vehiculos-electricos-de-Europa_04_HQ.avif)'
          }"
        >
          <div class="electrificationInterCard">
            <h2
              class="fw-light text-white text-uppercase p-2"
              style="font-size: 24px"
            >
              {{ 'electrificationTitleCardFour' | i18next }}
            </h2>
            <p
              class="text-white fw-light p-2 electrification-subtitle"
              style="font-size: 14px"
            >
              {{ 'electrificationSubtitleCardFour' | i18next }}
            </p>
            <div class="p-2">
              <button
                class="externalLinkButton"
                mat-button
                (click)="
                  navigateToExternalSite(
                    'https://www.cupraofficial.es/hibridos-y-electricos/carga-publica'
                  )
                "
              >
                {{ 'electrificationLinkCardFour' | i18next }}
              </button>
            </div>
          </div>
        </div>

        <!-- PLANIFICAR -->
        <div
          class="electrificationCard"
          [ngStyle]="{
            'background-image':
              'url(../../../assets/img/CUPRA-Tavascan-achieves-5-star-Euro-NCAP-safety-rating_01_HQ.avif)'
          }"
        >
          <div class="electrificationInterCard">
            <h2
              class="fw-light text-white text-uppercase p-2"
              style="font-size: 24px"
            >
              {{ 'electrificationTitleCardFive' | i18next }}
            </h2>

            <p
              class="text-white fw-light p-2 electrification-subtitle"
              style="font-size: 14px"
            >
              {{ 'electrificationSubtitleCardFive' | i18next }}
            </p>
            <div class="p-2">
              <button
                class="externalLinkButton"
                mat-button
                (click)="
                  navigateToExternalSite(
                    'https://www.cupraofficial.es/hibridos-y-electricos/planificador-de-ruta'
                  )
                "
              >
                {{ 'electrificationLinkCardFive' | i18next }}
              </button>
            </div>
          </div>
        </div>

        <!-- TARIFAS -->
        <div
          class="electrificationCard"
          [ngStyle]="{
            'background-image':
              'url(../../../assets/img/electric-vehicle-cupra-born-infotainment-navigation-system.avif)'
          }"
        >
          <div class="electrificationInterCard">
            <h2
              class="fw-light text-white text-uppercase p-2"
              style="font-size: 24px"
            >
              {{ 'electrificationTitleCardSix' | i18next }}
            </h2>
            <p
              class="text-white fw-light p-2 electrification-subtitle"
              style="font-size: 14px"
            >
              {{ 'electrificationSubtitleCardSix' | i18next }}
            </p>
            <div class="p-2">
              <button
                class="externalLinkButton"
                mat-button
                (click)="
                  navigateToExternalSite(
                    'https://www.cupraofficial.es/hibridos-y-electricos/tarifas-recarga'
                  )
                "
              >
                {{ 'electrificationLinkCardSix' | i18next }}
              </button>
            </div>
          </div>
        </div>

        <!-- CONSEJOS -->
        <div
          class="electrificationCard"
          [ngStyle]="{
            'background-image':
              'url(../../../assets/img/blue-cupra-tavascan-2024-electric-suv-coupe.avif)'
          }"
        >
          <div class="electrificationInterCard">
            <h2
              class="fw-light text-white text-uppercase p-2"
              style="font-size: 24px"
            >
              {{ 'electrificationTitleCardSeven' | i18next }}
            </h2>
            <p
              class="text-white fw-light p-2 electrification-subtitle"
              style="font-size: 14px"
            >
              {{ 'electrificationSubtitleCardSeven' | i18next }}
            </p>
            <div class="p-2">
              <button
                class="externalLinkButton"
                mat-button
                (click)="
                  navigateToExternalSite(
                    'https://www.cupraofficial.es/hibridos-y-electricos/tips'
                  )
                "
              >
                {{ 'electrificationLinkCardSeven' | i18next }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="showScrollUp" class="fixed-bottom border-0 bg-transparent m-4">
      <div class="d-flex align-items-center justify-content-end">
        <img
          (click)="scrollToTop()"
          style="
            width: 40;
            height: 40px;
            transform: rotate(180deg);
            cursor: pointer;
          "
          src="../../../assets/icons/scroll-down.svg"
          alt="Ir abajo"
        />
      </div>
    </div>
  </div>
</div>
